import { Grid, Slide } from "@mui/material";
import { InterpretationCardContainer } from "#pages/results/InterpretationCardContainer";
import React, { useRef } from "react";
import { useAppSelector } from "#store";

export type InterpretationsListingProps = { interpretationIds: number[] };

export function InterpretationsListing({
    interpretationIds,
}: InterpretationsListingProps) {
    const serviceUrl = useAppSelector(state => state.environment.SERVICE_URL);
    const csvForm = useRef<HTMLFormElement>(null);
    const csvFormQuery = useRef<HTMLTextAreaElement>(null);
    const csvFormDatabase = useRef<HTMLInputElement>(null);
    const csvFormRID = useRef<HTMLInputElement>(null);
    const csvFormSubmit = useRef<HTMLButtonElement>(null);
    const downloadCsv = (sql: string, dataset: string, rid: string) => {
        csvFormQuery.current!.value = sql;
        csvFormDatabase.current!.value = dataset;
        csvFormRID.current!.value = rid;
        csvForm.current!.requestSubmit(csvFormSubmit.current);
    };
    return (
        <>
            <Grid container spacing={2}>
                {interpretationIds.map(id => (
                    <Slide direction="up" in key={id}>
                        <Grid item sm={12}>
                            <InterpretationCardContainer
                                interpretationId={id}
                                downloadCsv={downloadCsv}
                            />
                        </Grid>
                    </Slide>
                ))}
            </Grid>
            <div style={{ display: "none" }}>
                <form
                    ref={csvForm}
                    action={serviceUrl + "/server/ql2csv"}
                    method="post"
                    target="interpretation_card_download_target"
                >
                    <textarea ref={csvFormQuery} name="query"></textarea>
                    <input ref={csvFormDatabase} type="text" name="database" />
                    <input ref={csvFormRID} type="text" name="rid" />
                    <button ref={csvFormSubmit} type="submit">
                        Submit
                    </button>
                </form>
                <iframe name="interpretation_card_download_target"></iframe>
            </div>
        </>
    );
}
